import { CommonModule } from '@angular/common';
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GoogleMapsModule, GoogleMap } from '@angular/google-maps';
import { OrderTrackingDetailComponent } from './order-tracking-detail/order-tracking-detail.component';
import { GlobalVariablesService } from '../../global.service';
import { APIService } from '../../fleet-management/backend-service/backend-service';
import { environment } from '../../../environments/environment';
import { LoadingService } from '../../services/loading.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-order-tracking',
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatIconModule,
    FormsModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    GoogleMapsModule
  ],
  templateUrl: './order-tracking.component.html',
  styleUrl: './order-tracking.component.scss'
})
export class OrderTrackingComponent implements OnDestroy {
  @ViewChild('map') mapComponent!: GoogleMap;

  constructor(private dialog: MatDialog, private apiService: APIService,
    private globalVariable: GlobalVariablesService, public loadingService: LoadingService) {
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(loading => this.isLoading = loading);
  }


  ngOnInit() {
    this.getOrderTrackingList();
  }

  searchText: string = '';
  orders: any[] = [];
  currentPage: number = 1;
  totalPages: number = 1;
  pageSize: number = 10;
  pages: number[] = [];
  selectedOrder: any = null;
  isLoading: boolean = false;
  private loadingSubscription: Subscription;

  // New properties for map and UI
  currentFilter: string = 'all';
  mapView: string = 'map';
  activeTab: string = 'tracking';
  mapCenter: google.maps.LatLngLiteral = { lat: 11.5564, lng: 104.9282 };
  mapOptions: google.maps.MapOptions = {
    zoom: 12,
    mapTypeId: 'roadmap',
    disableDefaultUI: false,
    zoomControl: true,
    streetViewControl: false,
    fullscreenControl: true
  };
  // orders1 = [
  //   {
  //     id: '1248075',
  //     status: 'Picked Up',
  //     progress: '20',
  //     from: { location: '456 Oak Avenue, Houston, Texas, USA', lat: '11.5271361', lng: '104.9175269' },
  //     to: { location: '789 Pine Street, Chicago, Illinois, USA', lat: '11.854646', lng: '104.7243412' },
  //     truckLocation: { lat: '11.760235030155075', lng: '104.82685755066548' },
  //     customer: { name: 'Mark Zuckerberg', image: 'assets/img/mark.png' },
  //     trackingStatus: {
  //       pickUp: {
  //         status: 'Pick up',
  //         location: '456 Oak Avenue, Houston, Texas, USA',
  //         date: '03.03.2025 at 8:00 AM',
  //         completed: true
  //       },
  //       onTheWay: {
  //         status: 'On the way',
  //         location: '645 Oak Avenue, Houston, Texas, USA',
  //         date: '06.03.2025 at 11:25 AM',
  //         completed: true
  //       },
  //       delivered: {
  //         status: 'Delivered',
  //         location: '789 Pine Street, Chicago, Illinois, USA',
  //         date: '09.03.2025 at 18:45 PM',
  //         completed: true
  //       },
  //     }
  //   },
  //   {
  //     id: '7894484',
  //     status: 'In Transit',
  //     progress: '40',
  //     from: { location: '362 Cast Avenue, Seattle, Washington, USA.', lat: '11.5271361', lng: '104.9175269' },
  //     to: { location: '789 Pine Street, Chicago, Oklahoma, USA.', lat: '11.487892359619346', lng: '105.11742830440573' },
  //     truckLocation: { lat: '11.510396049332309', lng: '105.04107953413305' },
  //     customer: { name: 'Elon Musk', image: 'assets/img/mask.png' },
  //     trackingStatus: {
  //       pickUp: {
  //         status: 'Pick up',
  //         location: '362 Cast Avenue, Seattle, Washington, USA',
  //         date: '03.06.2025 at 8:00 AM',
  //         completed: true
  //       },
  //       onTheWay: {
  //         status: 'On the way',
  //         location: '547 Pine Street, Chicago, Oklahoma, USA',
  //         date: '06.06.2025 at 11:25 AM',
  //         completed: false
  //       },
  //       delivered: {
  //         status: 'Delivered',
  //         location: '789 Pine Street, Chicago, Oklahoma, USA',
  //         date: '09.06.2025 at 18:45 PM',
  //         completed: false
  //       },
  //     }
  //   },
  //   {
  //     id: '41239110',
  //     status: 'In-transit',
  //     progress: '70',
  //     from: { location: '362 Cast Avenue, Seattle, Washington, USA.', lat: '11.5271361', lng: '104.9175269' },
  //     to: { location: '789 Pine Street, Chicago, Oklahoma, USA.', lat: '11.04957523932564', lng: '105.06460048391675' },
  //     truckLocation: { lat: '11.120893744235943', lng: '105.05651654867407' },
  //     customer: { name: 'Elon Musk', image: 'assets/img/mask.png' },
  //     trackingStatus: {
  //       pickUp: {
  //         status: 'Pick up',
  //         location: '362 Cast Avenue, Seattle, Washington, USA',
  //         date: '03.06.2025 at 8:00 AM',
  //         completed: true
  //       },
  //       onTheWay: {
  //         status: 'On the way',
  //         location: '547 Pine Street, Chicago, Oklahoma, USA',
  //         date: '06.06.2025 at 11:25 AM',
  //         completed: true
  //       },
  //       delivered: {
  //         status: 'Delivered',
  //         location: '789 Pine Street, Chicago, Oklahoma, USA',
  //         date: '09.06.2025 at 18:45 PM',
  //         completed: false
  //       },
  //     }
  //   },
  //   {
  //     id: '3568129',
  //     status: 'Delivered',
  //     progress: '100',
  //     from: { location: '456 Oak Avenue, Houston, Texas, USA', lat: '11.5271361', lng: '104.9175269' },
  //     to: { location: '789 Pine Street, Chicago, Illinois, USA', lat: '10.678134207152223', lng: '104.56290208546795' },
  //     truckLocation: { lat: '10.678134207152223', lng: '104.56290208546795' },
  //     customer: { name: 'Jeff Bezos', image: 'assets/img/jeff.png' },
  //     trackingStatus: {
  //       pickUp: {
  //         status: 'Pick up',
  //         location: '456 Oak Avenue, Houston, Texas, USA',
  //         date: '03.06.2025 at 8:00 AM',
  //         completed: true
  //       },
  //       onTheWay: {
  //         status: 'On the way',
  //         location: '789 Pine Street, Chicago, Illinois, US',
  //         date: '06.06.2025 at 11:25 AM',
  //         completed: true
  //       },
  //       delivered: {
  //         status: 'Delivered',
  //         location: '789 Pine Street, Chicago, Illinois, US',
  //         date: '09.06.2025 at 18:45 PM',
  //         completed: true
  //       },
  //     }
  //   },
  //   {
  //     id: '658944',
  //     status: 'Delayed',
  //     progress: '0',
  //     from: { location: '456 Oak Avenue, Houston, Texas, USA', lat: '11.5271361', lng: '104.9175269' },
  //     to: { location: '789 Pine Street, Chicago, Illinois, USA', lat: '11.5271361', lng: '104.9175269' },
  //     truckLocation: { lat: '11.5271361', lng: '104.9175269' },
  //     customer: { name: 'Mark Zuckerberg', image: 'assets/img/mark.png' },
  //     trackingStatus: {
  //       pickUp: {
  //         status: 'Pick up',
  //         location: '456 Oak Avenue, Houston, Texas, USA',
  //         date: '03.06.2025 at 8:00 AM',
  //         completed: false
  //       },
  //       onTheWay: {
  //         status: 'On the way',
  //         location: '789 Pine Street, Chicago, Illinois, US',
  //         date: '06.06.2025 at 11:25 AM',
  //         completed: false
  //       },
  //       delivered: {
  //         status: 'Delivered',
  //         location: '789 Pine Street, Chicago, Illinois, US',
  //         date: '09.06.2025 at 18:45 PM',
  //         completed: false
  //       },
  //     }
  //   }
  // ];

  getOrderTrackingList(page: number = 1) {
    this.orders = [];
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    console.log("LoginData: ", loginData)
    this.apiService.get(`/api/orders/tracking?page=${page}&limit=${this.pageSize}`, loginData.token).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log('/api/orders/tracking/list' + ',\n' + 'Order_Tracking_List_Response:', response.body);
        if (response.status === 200 || response.status === 201) {
          response.body.ordersTracking.forEach((data: { [x: string]: any; }) => {
            // Safely handle null deliveryLocation and pickupLocation
            let latDeliver = '0';
            let lngDeliver = '0';
            let latPickup = '0';
            let lngPickup = '0';
            let deliveryAddress = '';
            let pickupAddress = '';

            if (data["deliveryLocation"] && data["deliveryLocation"]["locationPin"]) {
              const locationPin = data["deliveryLocation"]["locationPin"];
              if (locationPin.length > 0) {
                const coords = locationPin.split(",");
                latDeliver = coords[0] || '0';
                lngDeliver = coords[1] || '0';
              }
              deliveryAddress = data["deliveryLocation"]["address"] || '';
            }

            if (data["pickupLocation"] && data["pickupLocation"]["locationPin"]) {
              const locationPin = data["pickupLocation"]["locationPin"];
              if (locationPin.length > 0) {
                const coords = locationPin.split(",");
                latPickup = coords[0] || '0';
                lngPickup = coords[1] || '0';
              }
              pickupAddress = data["pickupLocation"]["address"] || '';
            }

            console.log("Lat: ", latDeliver);
            console.log("Lng: ", lngDeliver);
            try {
              this.orders.push({
                id: data["id"],
                reference: data["reference"] || 'N/A',
                status: data["orderBookingStatus"],
                progress: data["progress"] ? data["progress"].toString() : '0',
                from: { location: pickupAddress, lat: latPickup, lng: lngPickup },
                to: { location: deliveryAddress, lat: latDeliver, lng: lngDeliver },
                truckLocation: { lat: '11.5271361', lng: '104.9175269' },
                customer: { name: data["customer"]["name"], image: environment.imageUrl + data["customer"]["picture"] },
                driver: data["driver"] ? {
                  contactNumber: data["driver"]["primaryContactNumber"] || data["driver"]["secondaryContactNumber"] || null
                } : null,
                trackingStatus: data["trackingStatus"] ? data["trackingStatus"] : {},
                // trackingStatus: {
                //   pickUp: {
                //     status: 'Pick up',
                //     location: '456 Oak Avenue, Houston, Texas, USA',
                //     date: '03.06.2025 at 8:00 AM',
                //     completed: false
                //   },
                //   onTheWay: {
                //     status: 'On the way',
                //     location: '789 Pine Street, Chicago, Illinois, US',
                //     date: '06.06.2025 at 11:25 AM',
                //     completed: false
                //   },
                //   delivered: {
                //     status: 'Delivered',
                //     location: '789 Pine Street, Chicago, Illinois, US',
                //     date: '09.06.2025 at 18:45 PM',
                //     completed: false
                //   },
                // }
              })
              console.log("Order Data: ", this.orders);
            } catch (error) {

            }
          });
          console.log("Data: ", this.orders);
          this.totalPages = response.body.pagination.totalPages;
          this.pages = Array(this.totalPages).fill(0).map((_, i) => i + 1);
          this.currentPage = page;
        }
        else {
          console.log("Hey you")
        }
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }
  get filteredOrders() {
    return this.orders.filter(order =>
      order.reference.includes(this.searchText) ||
      order.customer.name.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  get filteredOrdersList() {
    let filtered = this.orders.filter(order =>
      order.reference.includes(this.searchText) ||
      order.customer.name.toLowerCase().includes(this.searchText.toLowerCase())
    );

    if (this.currentFilter === 'in-transit') {
      filtered = filtered.filter(order =>
        order.status === 'In Transit' ||
        order.status === 'In-transit' ||
        order.status?.toLowerCase() === 'in transit' ||
        order.status?.toLowerCase() === 'in-transit'
      );
    } else if (this.currentFilter === 'delivered') {
      filtered = filtered.filter(order =>
        order.status?.toLowerCase() === 'delivered'
      );
    }

    return filtered;
  }

  getFilteredCount(status: string): number {
    return this.orders.filter(order => {
      const orderStatus = order.status?.toLowerCase() || '';
      const compareStatus = status.toLowerCase().replace('-', ' ');
      return orderStatus === compareStatus || orderStatus === status.toLowerCase();
    }).length;
  }

  selectOrder(order: any) {
    this.selectedOrder = order;
    if (order.from?.lat && order.from?.lng) {
      this.mapCenter = {
        lat: parseFloat(order.from.lat),
        lng: parseFloat(order.from.lng)
      };
    }
  }

  closeDetailPanel() {
    this.selectedOrder = null;
  }

  onMapClick(event: google.maps.MapMouseEvent) {
    console.log('Map clicked:', event.latLng?.toJSON());
  }

  // Icon methods for map markers
  getStartIcon(): google.maps.Icon {
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" fill="#000" stroke="#fff" stroke-width="2"/>
        </svg>
      `),
      scaledSize: new google.maps.Size(32, 32),
      anchor: new google.maps.Point(16, 16)
    };
  }

  getTruckIcon(): google.maps.Icon {
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="11" fill="#2196F3"/>
          <path d="M18 18.5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m1.5-9l1.96 2.5H17V9.5M6 18.5a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 6 15.5A1.5 1.5 0 0 1 7.5 17A1.5 1.5 0 0 1 6 18.5M20 8h-3V4H3c-1.11 0-2 .89-2 2v11h2a3 3 0 0 0 3 3a3 3 0 0 0 3-3h6a3 3 0 0 0 3 3a3 3 0 0 0 3-3h2v-5z" fill="#fff"/>
        </svg>
      `),
      scaledSize: new google.maps.Size(40, 40),
      anchor: new google.maps.Point(20, 20)
    };
  }

  getEndIcon(): google.maps.Icon {
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 24 32">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#f44336" stroke="#fff" stroke-width="1"/>
        </svg>
      `),
      scaledSize: new google.maps.Size(32, 42),
      anchor: new google.maps.Point(16, 42)
    };
  }

  // Helper method for parsing float values in template
  parseFloat(value: string): number {
    return parseFloat(value);
  }

  // Action methods for detail panel
  copyOrderId() {
    if (this.selectedOrder) {
      navigator.clipboard.writeText(this.selectedOrder.reference || this.selectedOrder.id);
      console.log('Order ID copied');
    }
  }

  editOrder() {
    console.log('Edit order:', this.selectedOrder);
  }

  deleteOrder() {
    console.log('Delete order:', this.selectedOrder);
  }

  callDialogNumber: string | null = null;

  showCallDialog(phoneNumber: string) {
    this.callDialogNumber = phoneNumber;
  }

  callDriver(phoneNumber: string) {
    this.callDialogNumber = null;
    window.open(`tel:${phoneNumber}`, '_self');
  }

  onClickCardStatus(order: any) {
    this.dialog.open(OrderTrackingDetailComponent, {
      width: '100%',
      height: '550px',
      maxWidth: '500px',
      data: { data: JSON.stringify(order) }
    });
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }
}
